import React from 'react';

export function ModeSwitch({ mode, onModeChange }) {
  const isPKI = mode === 'PKI';

  return (
    <button
      onClick={(e) => {
        e.stopPropagation(); // Prevent cube click handler
        onModeChange(isPKI ? 'KI' : 'PKI');
      }}
      className="relative inline-flex items-center rounded-full transition-all duration-300 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 cursor-pointer active:scale-95 bg-gray-200 p-1 flex-shrink-0"
      style={{
        width: '9rem',
        zIndex: 100,
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'transparent',
        outline: 'none'
      }}
    >
      {/* Background slider */}
      <span
        className={`absolute top-1 bottom-1 rounded-full transition-all duration-300 ease-out ${isPKI ? 'bg-pink-500' : 'bg-blue-500'}`}
        style={{
          width: 'calc(50% - 0.25rem)',
          left: isPKI ? 'calc(50%)' : '0.25rem'
        }}
      />

      {/* KI Label */}
      <span
        className={`flex-1 text-center py-3 text-sm lg:text-base font-semibold transition-all duration-300 z-10 ${
          !isPKI ? 'text-white scale-110' : 'text-blue-500 scale-100'
        }`}
      >
        KI
      </span>

      {/* PKI Label */}
      <span
        className={`flex-1 text-center py-3 text-sm lg:text-base font-semibold transition-all duration-300 z-10 ${
          isPKI ? 'text-white scale-110' : 'text-pink-500 scale-100'
        }`}
      >
        PKI
      </span>
    </button>
  );
}
